export const ru = {
    amount_placeholder: 'Укажите сумму пополнения',
    balance_invoice: 'Пополнение счета',
    balance_invoice_description: 'После введения суммы пополнения будет сформирован счет, который нужно скачать и оплатить.',
    invoice_download_description: 'Вы можете скачать счет и оплатить его.',
    digits_only: 'Введено некоректное значение',
};
